import { useState } from 'react'
import { Navigate } from 'react-router'
import {
  GENERIC_PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_TITLE,
} from '../../constants/ui.labels'
import { SETTINGS_PAGE } from '../../constants/links'
import { ChangePasswordForm } from '../../components'
import { ContentHeader, Error } from 'mfa'
import mapError from '../../utils/mapError/userManagement'

const INITIAL_FORM_STATE = {
  oldPassword: '',
  password: '',
  passwordConfirmation: '',
  error: null,
  isValid: false,
}

const ChangePassword = ({
  processed,
  errorCode = null,
  disabledForm = false,
  onSubmit,
}) => {
  const [formState, setFormState] = useState(INITIAL_FORM_STATE)
  const [displayToastError, setDisplayToastError] = useState(false)

  const { oldPassword, password, passwordConfirmation, error, isValid } =
    formState

  const hasAllPasswordsPresent = !!oldPassword && isValid

  const handleFormChange = (formData) =>
    setFormState((prev) => ({ ...prev, ...formData }))

  const getErrorMessage = (code) =>
    error || (code && mapError(code, GENERIC_PASSWORD_CHANGE_ERROR))

  const handleFormSubmit = (event) => {
    event.preventDefault()
    onSubmit({ oldPassword, password })
    setDisplayToastError(true)
  }

  if (processed) {
    return <Navigate to={SETTINGS_PAGE} replace />
  }

  const showToastError = (error && !isValid) || displayToastError

  return (
    <>
      <ContentHeader title={PASSWORD_CHANGE_TITLE} />
      {showToastError ? <Error message={getErrorMessage(errorCode)} /> : null}
      <ChangePasswordForm
        oldPassword={oldPassword}
        password={password}
        passwordConfirmation={passwordConfirmation}
        onFormChange={handleFormChange}
        onSubmit={handleFormSubmit}
        disabledForm={disabledForm}
        isValid={hasAllPasswordsPresent}
      />
    </>
  )
}

export default ChangePassword
